import React from "react";
import { LocalizationContext } from "../../../core/localization/Localization";
import { useDomForSideOptions } from "../../../data/settings/securityaccounts/hooks/useDomForSideOptions";
import { TextField, MenuItem, TextFieldProps } from "@material-ui/core";
import { DomForSide } from "../../../data/models";

interface DomForSideSelectProps {
	side?: DomForSide;
	handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	disabled?: boolean;
	nullable?: boolean;
	classes?: TextFieldProps['classes']
}

export const DomForSideSelect: React.FunctionComponent<DomForSideSelectProps> = ({
	side,
	handleChange,
	disabled,
	nullable,
	classes,
}) => {
	const { getString } = React.useContext(LocalizationContext);
	const options = useDomForSideOptions();
/*	const enchanchedOptions = React.useMemo(() => {
		return !nullable ? options : [
			{
				label: "--",
				value: "",
			},
			...options
		]
	}, [nullable, options])  */

	const enchanchedOptions = React.useMemo(() => {
		return  options 
	}, [ options])
	
	return (
		<TextField
			name="side"
			value={side?.toUpperCase() || ""}
			onChange={handleChange}
			fullWidth
			select
			label={getString("orderSide")}
			disabled={disabled}
			classes={classes}
		>
			{enchanchedOptions.map(option => (
				<MenuItem key={option.value} value={option.value}>
					{option.label}
				</MenuItem>
			))}
		</TextField>
	);
};
